import styled from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  ${respondTo.desktop`
     padding: 0 20px;
     display: flex;
     width: 100%;
     align-items: flex-start;
     flex-direction: row;
  `}
`;

export const StyledMenu = styled.ul`
  margin-top: 10px;
  list-style: none;
  min-width: 360px;
  ${respondTo.desktop`
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

    background-color: #ffffff;
    max-width: 360px;
    border-radius: 8px;
  `}
`;

export const CreateLink = styled.a`
  padding: ${({ padding = '11px 0' }) => padding};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: right;
  color: #ff7828;
  cursor: pointer;
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')}
    ${respondTo.mobile`
    margin-top: ${({ mobileMt = 0 }) => mobileMt}px;
  `};
`;
